import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const CustomHeaderButtonStyled = styled.button`
  background: ${Colors?.bgButton1};
  color: ${Colors?.ftColor4};
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.3s ease;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(52, 99, 156, 0.2);

  &:hover {
    background: ${Colors?.bgButton3};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(52, 99, 156, 0.3);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(52, 99, 156, 0.2);
  }

  i {
    font-size: 18px;
  }

  span {
    margin-left: 8px;
    font-size: 0.85rem;
    font-weight: 500;
  }
`;

export const InformationPage = styled.div`
  display: flex;
  flex-direction: column;
  ${props => {
    if (props.noMargin) return `margin-botton: 0;`;
    else return `margin-bottom: 1rem;`;
  }}

  .top-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${props => (props?.topMain ? '1rem' : '0')};
    box-shadow: 0px 7px 7px rgb(0 0 0 / 6%);
    background: ${props => (props?.topMain ? Colors.Color13 : Colors.Color13)};
    border-radius: 1rem 1rem 0 0;
    padding: 0.6rem 1rem 0.6rem 1rem;

    .lateral-e {
      display: flex;
      flex-direction: column;

      .divTitle {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .div-icone {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          background: ${Colors.Color2};
          border-radius: 0.4rem;
          padding: 0.15rem 0.8rem 0.15rem 0.3rem;

          img {
            width: 1.2rem;
          }

          .title {
            font-size: 0.7125rem;
            font-weight: 700;
            color: ${Colors?.Color7};
            margin-left: 0.5rem;
          }
        }

        .subTitle {
          margin-top: 0.5rem;
          font-size: 0.7125rem;
          font-weight: 500;
          color: ${Colors?.Color7};
        }
      }
    }

    .lateral-d {
      .ThisTopComponent_buttons {
        display: flex;
        flex-direction: row;
        align-items: center;

        .ThisTopComponent_buttons_firstButton {
          margin-right: 1rem;
        }

        .btn_circle {
          height: 2.1rem;
          width: 2.2rem;
          padding: 0rem;
        }
      }
    }

    .lateral-d1 {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      .ThisTopComponent_buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 1rem;

        .ThisTopComponent_buttons_firstButton {
          margin-right: 1rem;
        }

        .btn_circle {
          height: 2.1rem;
          width: 2.2rem;
          padding: 0rem;
        }
      }

      .pesquisa {
        margin-right: 1rem;

        input {
          width: 18rem !important;
          height: 2.9rem !important;
          background: ${Colors.Color22};
        }

        select {
          margin-right: 0.8rem;
          max-width: 9rem;
          background: ${Colors.Color13};
        }
      }

      .filtros {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        select {
          margin-right: 0.8rem;
          max-width: 9rem;
          background: ${Colors.Color13};
        }

        .btn-filtro {
          height: 2.1rem;
          width: 2.2rem;
          padding: 0rem;
          font-size: 0.88rem;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25rem solid ${Colors.Color4};
          border-radius: 0.4rem;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 1rem;
          }
        }
      }

      .btn-list {
        height: 2.1rem;
        width: 2.2rem;
        padding: 0rem;
        font-size: 0.88rem;
        font-weight: 600;
        background: ${Colors.Color22};
        border: 0.25rem solid ${Colors.Color22};
        border-radius: 0.4rem;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.6rem;

        img {
          width: 1.5rem;
        }
      }
    }
  }

  .top-body {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;

    .lateral-e {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .lateral-d {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;

      .pesquisa {
        margin-right: 1rem;
        margin-bottom: 0.8rem;
      }

      .filtros {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        select {
          margin-right: 0.8rem;
          max-width: 9rem;
        }

        .btn-filtro {
          height: 2.1rem;
          width: 2.2rem;
          padding: 0rem;
          font-size: 0.88rem;
          font-weight: 600;
          background: ${Colors.Color4};
          border: 0.25rem solid ${Colors.Color4};
          border-radius: 0.4rem;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 1rem;
          }
        }
      }
    }
  }
`;
